class MiniCart extends HTMLElement {
  constructor() {
    super();
  }


  resetDrawerScroll() {
    const reset = () => {
      const main =
        this.querySelector('.mini-cart__main');

      if (!main) return;

      main.scrollTop = 0;
      main.scrollLeft = 0;

      main.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    };


    reset();


    requestAnimationFrame(() => {
      reset();

      requestAnimationFrame(() => {
        reset();
      });
    });


    clearTimeout(
      this.__helmaCartResetTimer1
    );

    clearTimeout(
      this.__helmaCartResetTimer2
    );


    this.__helmaCartResetTimer1 =
      setTimeout(reset, 120);


    this.__helmaCartResetTimer2 =
      setTimeout(reset, 320);
  }


  connectedCallback() {
    this.header =
      document.querySelector(
        'sticky-header'
      );

    this.drawer =
      document.querySelector(
        'cart-drawer'
      );

    this.drawerDetails =
      this.drawer?.querySelector(
        'details'
      );


    if (this.drawerDetails) {
      this.drawerDetails.addEventListener(
        'toggle',
        () => {
          if (!this.drawerDetails.open) {
            return;
          }

          this.resetDrawerScroll();
        }
      );
    }


    new IntersectionObserver(
      this.handleIntersection.bind(this)
    ).observe(this);
  }


  handleIntersection(
    entries,
    observer
  ) {
    if (!entries[0].isIntersecting) {
      return;
    }


    observer.unobserve(this);


    fetch(this.dataset.url)
      .then((response) =>
        response.text()
      )
      .then((html) => {
        const miniCart =
          document.getElementById(
            'mini-cart'
          );


        if (!miniCart) return;


        miniCart.innerHTML =
          this.getSectionInnerHTML(
            html,
            '.shopify-section'
          );


        this.resetDrawerScroll();


        document.dispatchEvent(
          new CustomEvent(
            'cartdrawer:opened'
          )
        );
      })
      .catch((error) => {
        console.error(
          'Mini cart loading error:',
          error
        );
      });
  }


  open() {
    if (!this.drawer) return;


    const detailsElement =
      this.drawer.querySelector(
        'details'
      );


    if (!detailsElement) return;


    this.resetDrawerScroll();


    if (
      detailsElement.hasAttribute(
        'open'
      )
    ) {
      return;
    }


    this.drawer.openMenuDrawer();


    requestAnimationFrame(() => {
      this.resetDrawerScroll();
    });
  }


  renderContents(parsedState) {
    this.productId =
      parsedState.id;


    this.getSectionsToRender()
      .forEach((section) => {
        const element =
          document.getElementById(
            section.id
          );


        if (!element) return;


        element.innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[
              section.id
            ],
            section.selector
          );
      });


    this.resetDrawerScroll();


    document.dispatchEvent(
      new CustomEvent(
        'cart:added',
        {
          detail: {
            item: parsedState
          }
        }
      )
    );


    // Keep disabled:
    // this.open();
  }


  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section:
          'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(
        selector
      )
      .innerHTML;
  }
}


customElements.define(
  'mini-cart',
  MiniCart
);